// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"1319b87d","165":"ae993f3b","180":"257caa90","552":"343440e9","787":"c4b7a9ff"}[chunkId] + ".chunk.js";
};